module.exports = __webpack_public_path__ + "static/img/khfw18.c6431f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/customer_service/khfw18.png
// module id = iqpQ
// module chunks = 3